import React from 'react';
import { View, TouchableOpacity, Image, Clipboard } from 'react-native';
import { useToast } from "react-native-toast-notifications";

interface MessageCopyButtonProps {
    message: string;
}

export default function MessageCopyButton({ message }: MessageCopyButtonProps) {
    const toast = useToast();

    const copyMessageToClipboard = () => {

        Clipboard.setString(message);

        toast.show("Mensaje copiado al portapapeles", {
            type: "success",
            placement: 'top',
            animationType: 'zoom-in',
            style: {
                borderRadius: 15,
            },
        });
    };

    return (
        <View style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
        }}>
            <TouchableOpacity
                onPress={copyMessageToClipboard}
                style={{
                    padding: 8,
                    borderRadius: 8,
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                }}
                testID="copy-message-button"
            >
                <Image
                    source={require('../../../../assets/copy.png')}
                    style={{ 
                        width: 16, 
                        height: 16,
                        tintColor: '#ffffff',
                        opacity: 0.7
                    }}
                />
            </TouchableOpacity>
        </View>
    );
} 